/**
 * @flow
 * @relayHash effeabf5894c2f14e773dff03cf86c6f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type WithCartData_cart$ref = any;
export type CartInfoLoaderQueryVariables = {|
  guest_tokens?: ?$ReadOnlyArray<?string>
|};
export type CartInfoLoaderQueryResponse = {|
  +cart: ?{|
    +$fragmentRefs: WithCartData_cart$ref
  |}
|};
export type CartInfoLoaderQuery = {|
  variables: CartInfoLoaderQueryVariables,
  response: CartInfoLoaderQueryResponse,
|};
*/


/*
query CartInfoLoaderQuery(
  $guest_tokens: [String]
) {
  cart(guest_tokens: $guest_tokens) {
    ...WithCartData_cart
    id
  }
}

fragment WithCartData_cart on Cart {
  id
  ref_id
  name
  amount
  amount_in_qar
  quantity
  shipping_price
  raw_amount
  services_only
  least_state
  promo_code
  discount
  taxes
  selected_shipping_address {
    ref_id
    id
  }
  selected_billing_address {
    ref_id
    id
  }
  smart_cart
  user_smart_cart
  same_as_shipping
  payment_reference
  amount_with_cash
  amount_with_credit
  orders {
    guest_token
    amount
    id
    product_type
    selected_billing_address_id
    selected_shipping_address_id
    same_as_shipping
    vendor_branch_id
    ref_id
    total
    notes
    state
    promo_total
    tax_total
    adjustment_total
    free_shipping
    available_payment_methods {
      ref_id
      id
      name
    }
    line_items {
      created_at
      amount
      price
      warnings {
        field
        messages
        blocking
      }
      id
      quantity
      variant_services {
        ref_id
        id
      }
      variant {
        name
        id
        ref_id
        images
        price
        slug
        vendor_variants_count
        min_variant {
          vendor {
            name
            ref_id
            id
          }
          id
        }
        total_on_hand
        display_price
        images_attachments {
          url_original
          url_small
        }
        option_values {
          id
          name
          presentation
        }
        vendor {
          name
          active
          id
        }
      }
      total
    }
    vendor {
      name
      branches {
        ref_id
        name
        address
        lat
        lng
        inwani_building
        inwani_street
        inwani_zone
        id
      }
      payment_methods {
        ref_id
        name
        id
      }
      id
    }
    vendor_branch {
      ref_id
      name
      address
      lat
      lng
      inwani_building
      inwani_street
      inwani_zone
      id
    }
    payments {
      payment_method {
        ref_id
        name
        id
      }
      id
    }
    shipments {
      ref_id
      shipping_rates {
        ref_id
        base_price
        shipping_method {
          calculator {
            type
            id
          }
          ref_id
          name
          estimated_delivery_time
          id
        }
        id
      }
      shipping_rate_selected {
        ref_id
        base_price
        shipping_method {
          calculator {
            type
            id
          }
          ref_id
          name
          estimated_delivery_time
          id
        }
        id
      }
      id
    }
  }
  promotions {
    ref_id
    code
    id
  }
  user {
    avatar_details {
      url_original
      name
    }
    first_name
    last_name
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "guest_tokens",
    "type": "[String]",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "guest_tokens",
    "variableName": "guest_tokens",
    "type": "[String]"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "ref_id",
  "args": null,
  "storageKey": null
},
v7 = [
  v6,
  v2
],
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "same_as_shipping",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "total",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "price",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "url_original",
  "args": null,
  "storageKey": null
},
v12 = [
  v6,
  v3,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "address",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "lat",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "lng",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "inwani_building",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "inwani_street",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "inwani_zone",
    "args": null,
    "storageKey": null
  },
  v2
],
v13 = [
  v6,
  v3,
  v2
],
v14 = [
  v6,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "base_price",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "shipping_method",
    "storageKey": null,
    "args": null,
    "concreteType": "VendorShippingMethod",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "calculator",
        "storageKey": null,
        "args": null,
        "concreteType": "Calculator",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "type",
            "args": null,
            "storageKey": null
          },
          v2
        ]
      },
      v6,
      v3,
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "estimated_delivery_time",
        "args": null,
        "storageKey": null
      },
      v2
    ]
  },
  v2
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "CartInfoLoaderQuery",
  "id": null,
  "text": "query CartInfoLoaderQuery(\n  $guest_tokens: [String]\n) {\n  cart(guest_tokens: $guest_tokens) {\n    ...WithCartData_cart\n    id\n  }\n}\n\nfragment WithCartData_cart on Cart {\n  id\n  ref_id\n  name\n  amount\n  amount_in_qar\n  quantity\n  shipping_price\n  raw_amount\n  services_only\n  least_state\n  promo_code\n  discount\n  taxes\n  selected_shipping_address {\n    ref_id\n    id\n  }\n  selected_billing_address {\n    ref_id\n    id\n  }\n  smart_cart\n  user_smart_cart\n  same_as_shipping\n  payment_reference\n  amount_with_cash\n  amount_with_credit\n  orders {\n    guest_token\n    amount\n    id\n    product_type\n    selected_billing_address_id\n    selected_shipping_address_id\n    same_as_shipping\n    vendor_branch_id\n    ref_id\n    total\n    notes\n    state\n    promo_total\n    tax_total\n    adjustment_total\n    free_shipping\n    available_payment_methods {\n      ref_id\n      id\n      name\n    }\n    line_items {\n      created_at\n      amount\n      price\n      warnings {\n        field\n        messages\n        blocking\n      }\n      id\n      quantity\n      variant_services {\n        ref_id\n        id\n      }\n      variant {\n        name\n        id\n        ref_id\n        images\n        price\n        slug\n        vendor_variants_count\n        min_variant {\n          vendor {\n            name\n            ref_id\n            id\n          }\n          id\n        }\n        total_on_hand\n        display_price\n        images_attachments {\n          url_original\n          url_small\n        }\n        option_values {\n          id\n          name\n          presentation\n        }\n        vendor {\n          name\n          active\n          id\n        }\n      }\n      total\n    }\n    vendor {\n      name\n      branches {\n        ref_id\n        name\n        address\n        lat\n        lng\n        inwani_building\n        inwani_street\n        inwani_zone\n        id\n      }\n      payment_methods {\n        ref_id\n        name\n        id\n      }\n      id\n    }\n    vendor_branch {\n      ref_id\n      name\n      address\n      lat\n      lng\n      inwani_building\n      inwani_street\n      inwani_zone\n      id\n    }\n    payments {\n      payment_method {\n        ref_id\n        name\n        id\n      }\n      id\n    }\n    shipments {\n      ref_id\n      shipping_rates {\n        ref_id\n        base_price\n        shipping_method {\n          calculator {\n            type\n            id\n          }\n          ref_id\n          name\n          estimated_delivery_time\n          id\n        }\n        id\n      }\n      shipping_rate_selected {\n        ref_id\n        base_price\n        shipping_method {\n          calculator {\n            type\n            id\n          }\n          ref_id\n          name\n          estimated_delivery_time\n          id\n        }\n        id\n      }\n      id\n    }\n  }\n  promotions {\n    ref_id\n    code\n    id\n  }\n  user {\n    avatar_details {\n      url_original\n      name\n    }\n    first_name\n    last_name\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "CartInfoLoaderQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "cart",
        "storageKey": null,
        "args": v1,
        "concreteType": "Cart",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "WithCartData_cart",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "CartInfoLoaderQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "cart",
        "storageKey": null,
        "args": v1,
        "concreteType": "Cart",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "taxes",
            "args": null,
            "storageKey": null
          },
          v2,
          v3,
          v4,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "amount_in_qar",
            "args": null,
            "storageKey": null
          },
          v5,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "shipping_price",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "raw_amount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "services_only",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "least_state",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "promo_code",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "discount",
            "args": null,
            "storageKey": null
          },
          v6,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "selected_shipping_address",
            "storageKey": null,
            "args": null,
            "concreteType": "Address",
            "plural": false,
            "selections": v7
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "selected_billing_address",
            "storageKey": null,
            "args": null,
            "concreteType": "Address",
            "plural": false,
            "selections": v7
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "smart_cart",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "user_smart_cart",
            "args": null,
            "storageKey": null
          },
          v8,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "payment_reference",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "amount_with_cash",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "amount_with_credit",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "orders",
            "storageKey": null,
            "args": null,
            "concreteType": "Order",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "state",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "guest_token",
                "args": null,
                "storageKey": null
              },
              v2,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "product_type",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "selected_billing_address_id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "selected_shipping_address_id",
                "args": null,
                "storageKey": null
              },
              v8,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "vendor_branch_id",
                "args": null,
                "storageKey": null
              },
              v6,
              v9,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "notes",
                "args": null,
                "storageKey": null
              },
              v4,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "promo_total",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "tax_total",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "adjustment_total",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "free_shipping",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "available_payment_methods",
                "storageKey": null,
                "args": null,
                "concreteType": "PaymentMethod",
                "plural": true,
                "selections": [
                  v6,
                  v2,
                  v3
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "line_items",
                "storageKey": null,
                "args": null,
                "concreteType": "LineItem",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "created_at",
                    "args": null,
                    "storageKey": null
                  },
                  v4,
                  v10,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "warnings",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Error",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "field",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "messages",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "blocking",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  v2,
                  v5,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "variant_services",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Variant",
                    "plural": true,
                    "selections": v7
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "variant",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Variant",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "vendor_variants_count",
                        "args": null,
                        "storageKey": null
                      },
                      v3,
                      v6,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "images",
                        "args": null,
                        "storageKey": null
                      },
                      v10,
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "slug",
                        "args": null,
                        "storageKey": null
                      },
                      v2,
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "min_variant",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Variant",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "vendor",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Shop",
                            "plural": false,
                            "selections": [
                              v3,
                              v6,
                              v2
                            ]
                          },
                          v2
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "total_on_hand",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "display_price",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "images_attachments",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ImageAttachment",
                        "plural": true,
                        "selections": [
                          v11,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "url_small",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "option_values",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "OptionValue",
                        "plural": true,
                        "selections": [
                          v2,
                          v3,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "presentation",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "vendor",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Shop",
                        "plural": false,
                        "selections": [
                          v3,
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "active",
                            "args": null,
                            "storageKey": null
                          },
                          v2
                        ]
                      }
                    ]
                  },
                  v9
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "vendor",
                "storageKey": null,
                "args": null,
                "concreteType": "Shop",
                "plural": false,
                "selections": [
                  v3,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "branches",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "VendorBranch",
                    "plural": true,
                    "selections": v12
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "payment_methods",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PaymentMethod",
                    "plural": true,
                    "selections": v13
                  },
                  v2
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "vendor_branch",
                "storageKey": null,
                "args": null,
                "concreteType": "VendorBranch",
                "plural": false,
                "selections": v12
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "payments",
                "storageKey": null,
                "args": null,
                "concreteType": "Payment",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "payment_method",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PaymentMethod",
                    "plural": false,
                    "selections": v13
                  },
                  v2
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "shipments",
                "storageKey": null,
                "args": null,
                "concreteType": "Shipment",
                "plural": true,
                "selections": [
                  v6,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "shipping_rates",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ShippingRate",
                    "plural": true,
                    "selections": v14
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "shipping_rate_selected",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ShippingRate",
                    "plural": false,
                    "selections": v14
                  },
                  v2
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "promotions",
            "storageKey": null,
            "args": null,
            "concreteType": "Promotion",
            "plural": true,
            "selections": [
              v6,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "code",
                "args": null,
                "storageKey": null
              },
              v2
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "UserPublicInfo",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "avatar_details",
                "storageKey": null,
                "args": null,
                "concreteType": "ImageDetails",
                "plural": false,
                "selections": [
                  v11,
                  v3
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "first_name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "last_name",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '6bf5d27cfc1adecb39930cb5515cb24c';
module.exports = node;
